import { Poster } from '@/app/components/atoms/Poster'
import { YoutubeVideoThumb } from '@/app/components/shared/YoutubeVideoThumb'

import { toHeroGaleriaPromotionParams } from './HeroGaleria.analytics'
import styles from './HeroGaleria.module.scss'
import type { HeroGaleriaPage } from './HeroGaleria.types'
import { TrackedHeroTile } from './TrackedHeroTile'

interface HeroGaleriaMosaicPageProps {
  page: HeroGaleriaPage
  /** Posición (0-based) de la primera celda de esta página entre TODAS las del
   * mosaico — `index`/`creative_slot` de la analítica son absolutos. */
  indexOffset?: number
}

/**
 * Renderiza una única página del mosaico (`equal-3` o `split-4`) — pieza
 * compartida entre el render estático (1 página, `HeroGaleria.tsx`) y el
 * carrusel paginado (`HeroGaleriaCarousel`, 5-8 celdas), para no duplicar el
 * marcado del mosaico entre ambos casos.
 */
export function HeroGaleriaMosaicPage({ page, indexOffset = 0 }: HeroGaleriaMosaicPageProps) {
  const gridClassName = page.format === 'split-4' ? styles.gridSplit4 : styles.gridEqual3

  return (
    <div className={`${styles.grid} ${gridClassName}`}>
      {page.tiles.map((tile, position) => (
        <TrackedHeroTile
          key={tile.id}
          className={styles.cell}
          promotion={toHeroGaleriaPromotionParams(tile, indexOffset + position)}
        >
          {tile.kind === 'video' ? (
            <YoutubeVideoThumb videoId={tile.videoId} title={tile.title} />
          ) : (
            // Solo la primera celda de la primera página (la grande, visible
            // al cargar y candidata a LCP) va con prioridad; el resto, en
            // diferido, para no competir con ella.
            <Poster
              src={tile.src}
              alt={tile.alt}
              className={styles.cellImage}
              priority={indexOffset + position === 0}
            />
          )}
        </TrackedHeroTile>
      ))}
    </div>
  )
}
